import React, {startTransition, useEffect, useState} from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import AddNewPartComponent from "@pages/components/JobDetailsComponents/AddNewPartComponent";
import {
    CustomHeader,
    FleetButton
} from "@pages/new-design-components/custom-components";
import axios from "axios";
import notify from "@utils/notify";
import { FLEET_MS_API_URL } from "constants/index.js";

interface AwaitingPartsProps {
    showCreateNew: boolean;
    clearAndClose: () => void;
    getData:() => void;
    initialParts: any[];
    departments: any[];
    initialQuote: { [key: string]: any };
    initialVehicle: { [key: string]: any };
}
 const AwaitingPartsModal: React.FC<AwaitingPartsProps> = ({
                                                                   showCreateNew,
                                                                   clearAndClose,
                                                                   initialParts,
                                                                   initialQuote,
                                                                   initialVehicle,
                                                                   departments,
                                                                    getData,
                                                               }) => {

    const [parts, setParts] = useState<any[]>([]);

    const [quote, setQuote] = useState<{ [key: string]: any }>({});
    const [vehicle, setVehicle] = useState<{[key: string]: any}>({})
    useEffect(()=>{
        if (initialParts && initialParts.length) {
            setParts(structuredClone(initialParts));
        }
    },[initialParts])

    useEffect(()=>{
        if (initialQuote &&  Object.keys(initialQuote).length > 0) {
            setQuote(structuredClone(initialQuote));
        }
    },[initialQuote])

    useEffect(()=>{
        if (initialVehicle && Object.keys(initialVehicle).length > 0) {
            setVehicle(structuredClone(initialVehicle));
        }
    },[initialVehicle])


    const [deleteIds, setDeleteIds] = useState<(number|string)[]>([])

    const addNewRow = (quoteId: number) => {
        let tempData = [...parts]
        let row =  {
            part: null,
            department: null,
            part_number: null,
            cost: null,
            status: 'to_do',
            quote_id: quoteId,
        }
        tempData.push(row)
        setParts(tempData)
    }
    const changeData = ({index,key,value = null}:{index: number,key: string,value?: any}) => {
        let tempData = [...parts]
        tempData[index][key] = value
        if (tempData[index]?.id) {
            tempData[index]['edited'] = true
        }
        setParts(tempData)
    }
    const getQuoteParts = (quoteId: number) => {
        axios({
            method: 'GET',
            url: `${FLEET_MS_API_URL}/fleet-management/fleet-quote-details`,
            params: {
                quoteId,
            },
        }).then(res=>{
            const q = res.data.data
            setQuote(q)
            setParts(q.parts)
        }).catch(err=>{
            console.log('eee',err)
        })
    }
    const deleteRow = ({index,id}:{index: number, id: number | string}) => {
        let tempData = [...parts];
        let tempIds = [...deleteIds]
        if (id && !tempIds.includes(id)) {
            tempIds.push(id)
            setDeleteIds(tempIds)
        }
        tempData.splice(index, 1);
        setParts(tempData)
    }
    const deleteParts = async (deleted: any[]) => {
        try {
            const promises = deleted.map(item=>{
                axios.post(`${FLEET_MS_API_URL}/fleet-management/delete-missing-part`, {id: item})
            })
            await Promise.all(promises);
        } catch (error) {
            console.error('Error while deleting parts:', error);
        }
    }
    const savePart = async (data: any[]) => {
        try {
            const promises = data.map(item=>{
                axios.post(`${FLEET_MS_API_URL}/fleet-management/save-part`,
                    {...item,fleet_id: quote.fleet_id,vehicle_id: quote.vehicle_id})
            })
            await Promise.all(promises);
        } catch (error) {
            console.error('Error while deleting parts:', error);
        }
    }
    const saveData = async () => {
        const created = parts.filter(item => item.id === undefined);
        const updated = parts.filter(item => item.edited === true);

        try {
            if (deleteIds.length) {
                await deleteParts(deleteIds)
            }
            await savePart([...created,...updated])
            notify.success('Updated Parts successfully.');
            startTransition(() => {
                 setVehicle({})
                 setParts([])
                 setQuote({})
            });
            await getData()

        } catch (error) {
            notify.success('Error while updating.');
            console.error('Error while deleting images:', error);
        }
    }

    return (
        <Modal
            isOpen={showCreateNew}
            toggle={clearAndClose}
            modalClassName={'slide-in-from-right'}
            backdrop={false}
            className={'modal-dialog-right modal-responsible'}
        >
            <ModalHeader toggle={clearAndClose} className={'bg-white centered-title'}>
                <CustomHeader weight={'600'} fontSize={'14px'}  color={'#74787E'}>
                    Awaiting Parts
                </CustomHeader>
            </ModalHeader>
            <ModalBody>
                <AddNewPartComponent
                    addNewRow={addNewRow}
                    changeData={changeData}
                    getQuoteParts={getQuoteParts}
                    deleteRow={deleteRow}
                    vehicle={vehicle}
                    setVehicle={setVehicle}
                    departments={departments}
                    parts={parts}
                />
            </ModalBody>
            <ModalFooter>
                <div className={'d-flex flex-wrap g-10 w-100'}>
                    <FleetButton
                        height={'43px'}
                        width={'45%'}
                        backgroundColor={'#EB5855'}
                        color={'#FFFFFF'}
                        fontSize={'14px'}
                        radius={'8px'}
                        onClick={clearAndClose}
                    >
                        Close
                    </FleetButton>
                    <FleetButton
                        height={'43px'}
                        width={'45%'}
                        backgroundColor={'#F3994A'}
                        color={'#FFFFFF'}
                        fontSize={'14px'}
                        radius={'8px'}
                        onClick={saveData}
                    >
                        Save
                    </FleetButton>
                </div>
            </ModalFooter>
        </Modal>
        )
}
export default AwaitingPartsModal;
